<template>
  <div class="page-login">
    <Sbanner :detailInfo="detailOne" />
    <div class="container login-box">
      <div class="login-content">
        <h4 class="login-title">注册</h4>
        <div class="register-type">
          <label for="t1">
            <input type="radio" name="userType" id="t1" checked @change="changeRegisterType('t1')" />
            <em>普通用户</em>
          </label>
          <label for="t2">
            <input type="radio" name="userType" id="t2" @change="changeRegisterType('t2')" />
            <em>机构用户</em>
          </label>
        </div>

        <div class="login-item">
          <p class="txt">手机号</p>
          <div class="item-input">
            <input type="text" v-model="userTel" placeholder="请输入您的手机号">
          </div>
        </div>

        <div class="login-item">
          <p class="txt">手机验证码</p>
          <div class="item-input">
            <input type="text" v-model="code" placeholder="请输入手机验证码">
            <em class="label-right send-verify" :class="isCountDown ? 'isSend' : ''" @click="sendVerify">
              {{ isCountDown ? '重新获取（' + CountDownTime + 's）' : '发送验证码' }}
            </em>
          </div>
        </div>

        <div class="login-item" v-if="false">
          <p class="txt">用户名</p>
          <div class="item-input">
            <input type="text" v-model="username" placeholder="请输入您的用户名(6-20位)">
          </div>
        </div>

        <div class="login-item" v-if="false">
          <p class="txt">设置密码</p>
          <div class="item-input">
            <input type="password" v-model="pwd" placeholder="请设置登录密码(6-20位数字+字母)">
          </div>
        </div>

        <div class="login-item" v-if="false">
          <p class="txt">重复密码</p>
          <div class="item-input">
            <input type="password" v-model="pwd2" placeholder="请重复登录密码">
          </div>
        </div>

        <div v-show="registerType == 't2'" style="margin-top:20px">
          <div class="login-item">
            <p class="txt">法人</p>
            <div class="item-input">
              <input type="text" v-model="legal_person" placeholder="请输入法人真实姓名">
            </div>
          </div>

          <div class="login-item">
            <p class="txt">机构名称</p>
            <div class="item-input">
              <input type="text" v-model="org_name" placeholder="请输入机构全称">
            </div>
          </div>

          <div class="login-item">
            <p class="txt">统一识别码</p>
            <div class="item-input">
              <input type="text" v-model="org_code" placeholder="请输入机构统一识别码">
            </div>
          </div>

          <div class="login-item">
            <p class="txt">机构联系人</p>
            <div class="item-input">
              <input type="text" v-model="org_contact" placeholder="请输入机构联系人">
            </div>
          </div>

          <div class="login-item">
            <p class="txt">组织机构代码证</p>
            <div class="file_upload">
              <div class="imgPreview" v-if="codePic" @click="previewImg(showpath + codePic)">
                <img :src="showpath + codePic" alt="">
                <span class="imgDelete" title="删除图像" @click.stop="deleteImg">
                  <em class="iconfont icon-close-fill"></em>
                </span>
              </div>

              <span class="icon-add" v-else></span>
              <input type="file" class="input-file" ref="inputer" title="上传资料" @change="uploadImg"
                accept="image/gif, image/jpeg, image/jpg, image/png, image/svg" />
            </div>
          </div>
        </div>

        <div class="noticexx">
          <transition name="fade">
            <notice :type="'error'" v-if="noticeShow">
              <template v-slot:noticeTxt>
                {{ noticeWarn }}
              </template>
            </notice>
          </transition>
        </div>

        <div class="login-btn" @click="register">注册</div>
        <p class="login-tips">已有账号？<em @click="goPage('/login')">登录</em></p>
      </div>
    </div>
    <popInfo positions='fixed' v-if="loginSuccss">
      <div class="reback">
        <span class="iconfont icon-check"></span>
        <p v-html="loginTxt"></p>
      </div>
    </popInfo>

    <pop-info v-if="popShow">
      <p>{{ popTxt }}</p>
    </pop-info>

    <div class="imgPre" v-if="showPre" @click="closePre">
      <!-- <span class="close iconfont icon-close-fill"  @click="closePre"></span> -->
      <img :src="showpath + codePic" alt="">
    </div>
  </div>
</template>

<script>
import Sbanner from '../components/sbanner.vue'
import notice from "../components/common/notice.vue"
import popInfo from "../components/common/popInfo.vue"
import { encrypt, decrypt } from '../utils/sm4Util';
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'register',
  components: { Sbanner, notice, popInfo },
  props: {
    msg: String
  },
  data() {
    return {
      detailOne: {},
      noticeShow: false,
      noticeWarn: '',
      registerType: "t1",
      userTel: '',
      code: '',
      isCountDown: false,
      CountDownTime: 59,
      countDownFun: null,
      loginSuccss: false,
      username: '',
      pwd: '',
      pwd2: '',
      showpath: '',
      legal_person: '',
      org_name: '',
      org_code: '',
      org_contact: '',
      codePic: '',

      popShow: false,
      popTxt: '',
      showPre: false,
      loginTxt: ''
    }
  },
  computed: {
    ...mapState(['loginTimes']),

  },
  mounted() {
    if (this.$route.params.toPage) {
      this.nextPath = this.$route.params.toPage.replace(/-/g, "/")
    }
  },
  methods: {
    ...mapMutations(['updateUserInfo']),
    goPage(page) {
      if (page == 'login' && this.nextPath) {
        path = page + '/' + this.$route.params.toPage
      }
      this.$router.push(page)
    },

    changeRegisterType(type) {
      // console.log(type); 
      this.registerType = type
    },

    // 发送手机验证码
    sendVerify() {
      if (this.isCountDown) return;
      if (!this.userTel) {
        this.showWarn("请输入手机号获取验证码")
        return;
      }
      if (!this.$utils.isPhone(this.userTel)) {
        this.showWarn("请输入正确手机号")
        return;
      }
      let params = {
        phone: encrypt(this.userTel),
        type: 2
      }
      this.$api.userApi.getTelVerifyCode(params).then(res => {
        if (res.code == 0) {
          this.isCountDown = true;
          this.counDowning();
        } else {
          this.showWarn(res.msg)
        }
      });
    },
    // 倒计时
    counDowning() {
      this.countDownFun = setInterval(() => {
        this.CountDownTime = this.CountDownTime - 1;
        if (this.CountDownTime == 0) {
          clearInterval(this.countDownFun);
          this.isCountDown = false;
          this.CountDownTime = 59;
        }
      }, 1000);
    },

    registerOld() {
      if (this.isRegisting) {
        return;
      }
      this.isRegisting = true;
      if (!this.userTel || !this.username || !this.pwd || !this.pwd2 || !this.code) {
        this.showWarn("还有未填内容,请填空完成后再提交")
        return;
      }
      if (this.registerType == 't2') {
        if (!this.legal_person || !this.org_name || !this.org_code) {
          this.showWarn("还有未填内容,请填空完成后再提交")
          return;
        }
      }

      if (this.username.length < 6 || this.username.length > 20) {
        this.showWarn("用户名长度为6-20位")
        return;
      }
      // 两次密码是否一致
      if (this.pwd !== this.pwd2) {
        this.showWarn("两次输入的密码不一致");
        return;
      }

      // 密码长度6-20位
      if (this.pwd.length < 6 || this.pwd.length > 20) {
        this.showWarn("密码长度为6-20位");
        return;
      }

      var regPwdNum = /\d+/; //验证0-9的任意数字最少出现1次。
      var regPwdStr = /[a-zA-Z]+/;    //验证大小写26个字母任意字母最少出现1次。
      if (!regPwdNum.test(this.pwd) || !regPwdStr.test(this.pwd)) {
        this.showWarn("密码包含数字+字母");
        return;
      }

      let params = {
        username: this.username,
        password: encrypt(this.pwd),
        code: this.code,
        phone: encrypt(this.userTel),
        type: this.registerType == 't1' ? 1 : 2,
        name: '',
        legal_person: this.legal_person,
        org_name: this.org_name,
        org_code: this.org_code
      }
      this.$api.userApi.registerNew(params).then(res => {
        this.isRegisting = false;
        if (res.code === 0) {
          this.loginSuccss = true;
          setTimeout(() => {
            this.$router.push("/login")
            this.loginSuccss = false;
          }, 2000);
        } else {
          this.noticeWarn = res.msg;
          this.noticeShow = true;
          this.fadeOutWarn();
        }
      }).catch(() => {
        this.isRegisting = false;
      })
    },

    register() {
      if (this.isRegisting) {
        return;
      }

      this.isRegisting = true;
      if (!this.userTel || !this.code) {
        this.showWarn("还有未填内容,请填空完成后再提交")
        return;
      }
      // 手机号
      let telReg = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
      if (!telReg.test(this.userTel)) {
        this.showWarn("请输入正确的手机格式")
        return
      }

      if (this.registerType == 't2') {
        if (!this.legal_person || !this.org_name || !this.org_code || !this.org_contact || !this.codePic) {
          this.showWarn("还有未填内容,请填空完成后再提交")
          return;
        }
        var reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
        if (!reg.test(this.org_code)) {
          this.showWarn("统一识别码不正确")
          return
        }
        if (this.legal_person.length >= 20) {
          this.showWarn("法人名称不能超过20字")
          return
        }

        if (this.org_name >= 50) {
          this.showWarn("机构名称不能超过50字")
          return
        }
        if (this.org_contact >= 20) {
          this.showWarn("机构联系人不能超过20字")
          return
        }

      }

      let params = {
        username: '',
        password: '',
        code: this.code,
        phone: encrypt(this.userTel),
        type: this.registerType == 't1' ? 1 : 2,
        name: '',
        legal_person: this.legal_person,
        org_name: this.org_name,
        org_code: this.org_code,
        contacts_person: this.org_contact,
        certificate: this.codePic
      }
      this.$api.userApi.registerNew(params).then(res => {
        this.isRegisting = false;
        if (res.code === 0) {
          if (this.registerType == "t1") {
            this.loginTxt = "注册成功，<br/> 正在登录中..."
            this.loginSuccss = true;
            this.loginTel(res)
          } else {
            this.loginTxt = res.msg;
            this.loginSuccss = true;
            setTimeout(() => {
              this.$router.push("/index")
              this.loginSuccss = false;
            }, 1500);
          }
        } else {
          this.noticeWarn = res.msg;
          this.noticeShow = true;
          this.fadeOutWarn();
        }
      }).catch(() => {
        this.isRegisting = false;
      })
    },

    loginTel(res) {
      let loginInfo = {
        ...res.data,
        time: new Date().getTime(),
        user: res.data.username,
        ip: window.ip,
        userPic: res.data.cover_img,
        showpath: res.showpath,
        // phone:decrypt(res.data.phone)
      }
      this.updateUserInfo(loginInfo);
      this.$utils.setCookie("login", JSON.stringify(loginInfo), 30)
      this.$utils.setSession("lastLoginTime", new Date().getTime())
      setTimeout(() => {
        if (this.nextPath) {
          this.$router.replace(this.nextPath)
        } else {
          this.$router.replace("/index")
        }
        // this.$router.push("/index")
        this.loginSuccss = false;
      }, 1000);

    },

    uploadImg(e) {   // 上传照片
      let that = this
      let file = e.target.files[0]
      if (Math.floor(file.size / 1024) > 5 * 1024) {
        this.showWarn('请选择5M以内的图片！')
        return false;
      }
      /* eslint-disable no-undef */
      let param = new FormData()  // 创建form对象
      param.append('file', file)  // 通过append向form对象添加数据
      param.append('chunk', '0') // 添加form表单中其他数据
      // console.log(param.get('file')) // FormData私有类对象，访问不到，可以通过get判断值是否传进去

      this.popTxt = "上传中...";
      this.popShow = true;
      let params = {
        username: '',
        phone: this.userTel || '',
        param: param,
      }
      this.$api.userApi.Upload(params).then(res => {
        if (res.data.code == 0 && res.data.url) {
          this.showpath = res.data.showpath;
          this.codePic = res.data.url;

        }
        this.popTxt = res.data.msg;
        this.popShow = true
        setTimeout(() => {
          this.popShow = false;
        }, 2000);
      })
    },

    // 预览图片
    previewImg(e) {
      this.showPre = true;
      return
    },
    closePre(e) {
      this.showPre = false;
    },

    deleteImg(e) {
      this.codePic = ''
    },

    goHome() {
      this.$router.push({ path: '/index' })
    },
    reload() {
      this.$router.go(0)
    },

    showWarn(txt) {
      this.isRegisting = false;
      this.noticeWarn = txt;
      this.noticeShow = true;
      this.fadeOutWarn();
    },
    //隐藏警告提示框 
    fadeOutWarn() {
      setTimeout(() => {
        this.noticeShow = false;
        this.noticeWarn = '';
      }, 5000);
    },
  },
}
</script>